<template>
  <div>
    <px-nota-fiscal-item v-for="notaFiscal in notasFiscais"
                         :key="notaFiscal.id"
                         :nota-fiscal="notaFiscal"/>
  </div>
</template>

<script>
import NotaFiscalItem from '@/modules/notas-fiscais/NotaFiscalItem.vue';

export default {
  props: {
    notasFiscais: {
      type: Array,
      required: true,
    },
  },
  components: {
    pxNotaFiscalItem: NotaFiscalItem,
  },
};
</script>
